/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Partition value format
*/
export enum PartitionFormat {
  PARTITION_FORMAT_HIVE = 'HIVE',
  PARTITION_FORMAT_DIRECT = 'DIRECT'
}
